// src/pages/Home/data/applicationsData.js

import {
  FaBuilding,
  FaCalendarCheck,
  FaCity,
  FaDumbbell,
  FaHandshake,
  FaHardHat,
  FaMapMarkedAlt,
  FaPeopleCarry,
  FaPlayCircle,
  FaSearch,
  FaShieldAlt,
  FaUsers,
  FaVoteYea,
} from "react-icons/fa";

export const applicationFilters = [
  { key: "all", label: "Toutes les applications" },
  { key: "club", label: "Clubs sportifs" },
  { key: "collectivite", label: "Collectivités" },
  { key: "association", label: "Associations" },
  { key: "instance", label: "Comités & Ligues" },
  { key: "judo", label: "Judo" },
  { key: "entreprise", label: "Entreprises" },
];

export const applications = [
  {
    name: "MonAppliClub",
    target: "Clubs sportifs",
    filterKeys: ["club"],
    headline: "La gestion complète de votre club sportif",
    short:
      "Adhérents, inscriptions, documents, règlements, événements et communication réunis dans un seul outil.",
    image: "/images/products/001.png",
    to: "/product-monappliclub",
    icon: FaDumbbell,
    featured: true,
  },
  {
    name: "MonAppliClub Light",
    target: "Petits clubs",
    filterKeys: ["club"],
    headline: "L’essentiel pour gérer son club simplement",
    short:
      "Une solution accessible pour présenter le club, organiser ses informations et gagner du temps.",
    image: "/images/products/002.png",
    to: "/product-monappliclub-light",
    icon: FaDumbbell,
    featured: true,
  },
  {
    name: "MonAppliMairie",
    target: "Mairies & collectivités",
    filterKeys: ["collectivite"],
    headline: "Un site communal moderne et facile à administrer",
    short:
      "Actualités, agenda, élus, services, associations, commerces, publications et démarches locales.",
    image: "/images/products/003.png",
    to: "/product-monapplimairie",
    icon: FaCity,
    featured: true,
  },
  {
    name: "MonAppliAsso",
    target: "Associations",
    filterKeys: ["association", "collectivite"],
    headline: "Valorisez les associations de votre territoire",
    short:
      "Activités, horaires, lieux, coordonnées, actualités, événements et formulaires publics.",
    image: "/images/appli/illustration_monappliasso.png",
    to: "/product-monappliclub-omnisports",
    icon: FaUsers,
    featured: true,
  },
  {
    name: "MonAppliAG",
    target: "Clubs & associations",
    filterKeys: ["association", "club", "instance"],
    headline: "Organisez vos assemblées générales sereinement",
    short:
      "Émargement, procurations, quorum, documents, votes et résultats dans une interface unique.",
    image: "/images/products/011.png",
    to: "/monappliag",
    icon: FaVoteYea,
    featured: true,
  },
  {
    name: "MonAppliTournoi",
    target: "Clubs & organisateurs",
    filterKeys: ["club", "judo"],
    headline: "Pilotez vos tournois interclubs",
    short:
      "Inscriptions, catégories, combats, résultats, podiums et affichages pour vos événements sportifs.",
    image: "/images/appli/illustration_monapplitournoi.png",
    to: "/product-monappliclub-tournoi",
    icon: FaCalendarCheck,
    featured: true,
  },
  {
    name: "Judo Coach Pro",
    target: "Enseignants de judo",
    filterKeys: ["club", "judo"],
    headline: "Suivez la progression de vos judokas",
    short:
      "Objectifs, techniques, résultats, préparation aux grades et accompagnement individualisé.",
    image: "/images/appli/illustration_judocoachpro.png",
    to: "/product-judocoachpro",
    icon: FaPeopleCarry,
  },
  {
    name: "Présence Pro",
    target: "Clubs & associations",
    filterKeys: ["club", "judo", "association"],
    headline: "Simplifiez le suivi des présences",
    short:
      "Pointage rapide, suivi des groupes et statistiques de fréquentation tout au long de la saison.",
    image: "/images/appli/illustration_presencepro.webp",
    to: "/product-judopresencepro",
    icon: FaUsers,
  },
  {
    name: "MonAppliKata",
    target: "Judokas",
    filterKeys: ["judo"],
    headline: "Trouvez facilement un partenaire de kata",
    short:
      "Une plateforme de mise en relation pour préparer les passages de grades et les compétitions.",
    image: "/images/products/008.png",
    to: "/partenaires-kata",
    icon: FaHandshake,
  },
  {
    name: "MonAppliCaté",
    target: "Judokas & parents",
    filterKeys: ["judo"],
    headline: "Identifiez votre catégorie en quelques secondes",
    short:
      "Retrouvez la catégorie d’âge et de poids correspondant à la saison sportive.",
    image: "/images/products/009.png",
    to: "/monapplicate",
    icon: FaSearch,
  },
  {
    name: "MonAppliScore",
    target: "Clubs, Comités",
    filterKeys: ["judo"],
    headline: "Suivez les scores en temps réel",
    short:
      "Un véritable tableau de score directement depuis votre navigateur.",
    image: "/images/appli/monappliscore2.webp",
    to: "/monappliscore",
    icon: FaSearch,
  },
  {
    name: "Randori Cards",
    target: "Passionnés de judo",
    filterKeys: ["judo"],
    headline: "Un jeu de cartes en ligne inspiré du judo",
    short:
      "Techniques, actions et situations de combat réunies dans une expérience ludique.",
    image: "/images/products/010.png",
    to: "https://www.randori-cards.com/",
    external: true,
    icon: FaPlayCircle,
  },
  {
    name: "MonAppliComité",
    target: "Comités départementaux",
    filterKeys: ["instance", "judo"],
    headline: "Une plateforme au service de votre territoire",
    short:
      "Clubs, commissions, événements, documents, communication et services départementaux.",
    image: "/images/products/012.png",
    to: "/monapplicomite",
    icon: FaMapMarkedAlt,
  },
  {
    name: "MonAppliLigue",
    target: "Ligues régionales",
    filterKeys: ["instance", "judo"],
    headline: "Centralisez les services de votre ligue",
    short:
      "Calendriers, clubs, formations, commissions, documents, votes et outils internes.",
    image: "/images/products/013.png",
    to: "/monappliligue",
    icon: FaBuilding,
  },
  {
    name: "Solution sur mesure",
    target: "Entreprises & artisans",
    filterKeys: ["entreprise"],
    headline: "Une application adaptée à votre activité",
    short:
      "Site vitrine, outil métier, portail public, espace client ou application interne.",
    image: "/images/appli/illustration_website.png",
    to: "#contact",
    icon: FaHardHat,
  },
];